<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M14.8111 9.43573C17.0887 9.43573 18.9351 8.38679 18.9351 7.09286C18.9351 5.79894 17.0887 4.75 14.8111 4.75C12.5334 4.75 10.687 5.79894 10.687 7.09286C10.687 8.38679 12.5334 9.43573 14.8111 9.43573Z"
        fill="#B7BDCD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8728 10.7842C11.9232 10.7842 10.7488 9.54807 10.7488 8.83203V11.8992C10.7488 13.1936 12.5953 14.2409 14.8728 14.2409C17.1528 14.2409 18.9993 13.1936 18.9993 11.8992V8.90565C18.9993 9.62288 17.8237 10.7842 14.8728 10.7842Z"
        fill="#B7BDCD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8728 15.5235C12.2343 15.5235 10.7488 14.3349 10.7488 13.6188V16.6576C10.7488 17.9519 12.5953 19.0004 14.8728 19.0004C17.1528 19.0004 18.9993 17.9519 18.9993 16.6576V13.582C18.9993 14.2981 17.5126 15.5235 14.8728 15.5235Z"
        fill="#B7BDCD"
      />
      <path
        d="M4.67504 4.68573C7.25699 4.68573 9.35008 3.63679 9.35008 2.34286C9.35008 1.04894 7.25699 0 4.67504 0C2.09309 0 0 1.04894 0 2.34286C0 3.63679 2.09309 4.68573 4.67504 4.68573Z"
        fill="#B7BDCD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.82348 6.03422C1.48077 6.03422 0.148438 4.79807 0.148438 4.08203V7.14925C0.148438 8.44358 2.24193 9.49092 4.82348 9.49092C7.40739 9.49092 9.4997 8.44358 9.4997 7.14925V4.15565C9.4997 4.87288 8.16618 6.03422 4.82348 6.03422Z"
        fill="#B7BDCD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.82348 10.7735C1.83226 10.7735 0.148438 9.58488 0.148438 8.86884V11.9076C0.148438 13.2019 2.24193 14.2504 4.82348 14.2504C7.40739 14.2504 9.4997 13.2019 9.4997 11.9076V8.83203C9.4997 9.54807 7.81351 10.7735 4.82348 10.7735Z"
        fill="#B7BDCD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.82348 15.5235C1.83226 15.5235 0.148438 14.3349 0.148438 13.6188V16.6576C0.148437 17.9519 2.24193 19.0004 4.82348 19.0004C7.40739 19.0004 9.4997 17.9519 9.4997 16.6576V13.582C9.4997 14.2981 7.81351 15.5235 4.82348 15.5235Z"
        fill="#B7BDCD"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
